// @flow
import React, { Component } from 'react';
import type { ComponentType, ElementRef, Node } from 'react';
import type { Untranslated } from '@rover/shared/js/types';
import styled, { type StyledComponent } from 'styled-components';
import classNames from 'classnames';

import { DSToken, Spacing } from '@rover/react-lib/styles';

import FormGroup from '../../formFields/FormGroup';
import FormValidationError from '../../formFields/FormValidationError';
import { getNextId } from '../../../utils/elementIdCreator';
import Popover from '../../callouts/Popover';

export type Props = {
  id?: string,
  name?: string,
  children?: any => Node,
  label?: Node,
  subLabel?: Node,
  placeholder?: Untranslated,
  className?: string,
  validationError?: ?Untranslated,
  validationErrorPlacement?: Popover.Placement,
  style?: any,
  inputRef?: (ElementRef<any>) => void,
  InputComponent?: ComponentType<any>,
  usingAriaLabelledby?: boolean,
};

export const Label: StyledComponent<{}> = styled.label`
  font-weight: 700;
  color: ${DSToken.TEXT_COLOR_SECONDARY};
  margin-bottom: ${Spacing.XS};
`;

export const SubLabel: StyledComponent<{}> = styled.div`
  line-height: 1.6;
  color: ${DSToken.TEXT_COLOR_TERTIARY};
  margin-bottom: 6px;
`;

export default class LabelAndErrorFormGroup extends Component<Props> {
  id = getNextId();

  render() {
    const {
      id,
      InputComponent,
      className,
      children,
      style,
      label,
      name,
      subLabel,
      inputRef,
      usingAriaLabelledby,
      placeholder,
      validationError,
      validationErrorPlacement,
      ...other
    } = this.props;
    let labelComponent = null;
    let childrenComponent = null;

    if (label) {
      const labelProps = {
        className: 'control-label',
        htmlFor: usingAriaLabelledby ? undefined : id || `${name || ''}-${this.id}`,
        id: usingAriaLabelledby ? id || `${name || ''}-${this.id}` : undefined,
        children: label,
      };
      // eslint-disable-next-line jsx-a11y/label-has-for
      labelComponent = <Label {...labelProps} />;
    }

    const inputComponentProps = {
      ...other,
      ref: inputRef,
      name,
      id: id || `${name || ''}-${this.id}`,
      placeholder: placeholder || (typeof label === 'string' ? label : ''),
    };

    if (InputComponent) {
      childrenComponent = <InputComponent {...inputComponentProps} />;
    } else if (children) {
      // support function as child
      childrenComponent = children(inputComponentProps);
    }
    return (
      <FormGroup className={classNames({ 'has-error': validationError }, className)} style={style}>
        {labelComponent}
        {subLabel && <SubLabel>{subLabel}</SubLabel>}
        <FormValidationError message={validationError} placement={validationErrorPlacement}>
          {childrenComponent}
        </FormValidationError>
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/LabelAndErrorFormGroup/LabelAndErrorFormGroup.jsx